<template>
  <pop-up-layout
      :title="localization.modificarTipo"
      :loading="waitingForLoad"
      :aceptar="localization.guardar"
      :saving="waitingForLoad"
      :disabled="!cambiado"
      @aceptar="guardar()"
      @volver="$parent.hide()"
    >
    <v-form v-model="valid" id="valid" ref="form">
      <v-row justify="center">
        <v-col cols="8">
          <v-layout wrap justify-center>
            <v-flex xs12 sm12 md12 lg12 pl-1 pr-1>
              <v-autocomplete 
                :no-data-text="$t('sinDatos')"
                v-model="codTipoSelected" id="codTipoSelected"
                :items="tiposSol"
                :label="localization.tiposSolicitudes"
                :item-text="mostrarIdioma"
                item-value="codigoTipoSolicitud"
                :rules="[rules.obligatorio]">
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-menu v-model="datePickerMenu" id="datePickerMenu" :close-on-content-click="false"
            :nudge-right="40" transition="scale-transition"
            offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="statusDateFormated" id="statusDateFormated"
                :label="localization.fecha"
                prepend-icon="event"
                :rules="[rules.date]"
                v-on="on"
                v-on:keypress="evitarKeyPress($event)"
              />
            </template>
            <v-date-picker v-model="statusDate" id="statusDate" @input="datePickerMenu = false" locale="es"/>
          </v-menu>
        
          <v-text-field v-model="observaciones" id="observaciones" :label="localization.observaciones" autocomplete="disabled" :rules="[rules.obligatorio]"/>
        </v-col>
      </v-row>
    </v-form>
  </pop-up-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import moment from 'moment'

export default {
  mixins: [rulesMixin],
  props: {
    solicitud: Object
  },
  data () {
    return {
      codTipoSelected: '',
      observaciones: '',
      nombreClienteCierre: '',
      nifClienteCierre: '',
      statusDate: new Date().toISOString().substr(0, 10),
      datePickerMenu: false,
      waitingForLoad: false,
      cambiado: false,
      valid: true
    }
  },
  computed: {
    ...mapGetters({
      configuracionStore: 'configuracion/getConfiguracion',
      rolProveedor: 'login/rolProveedor',
      tiposSolicitud: 'configuracion/getTiposSolicitud',
      getAllTiposSolicitud: 'configuracion/getAllTiposSolicitud'
    }),
    tiposSol () {
      // 290267 - En el desplegable tienen que aparecer las solicitudes disponibles, no solo las que tenga activas el supervisor
      let tipoSol = this.solicitud.codigoTipoSolicitud ? this.solicitud.codigoTipoSolicitud : this.solicitud.idSolicitud
      return this.getAllTiposSolicitud.filter(item => tipoSol !== item.codigoTipoSolicitud && item.habilitar)
    }, 
    localization () {
      return this.$t('popUpCambiarTipo')
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    statusDateFormated () {
      return (this.statusDate) ? moment(this.statusDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },

  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add'
    }),
    close () {
      this.$emit('input')
    },
    guardar () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        let tipoSol = this.solicitud.codigoTipoSolicitud ? this.solicitud.codigoTipoSolicitud : this.solicitud.idSolicitud
        let tipoInicial = this.getAllTiposSolicitud.find(item => item.codigoTipoSolicitud == tipoSol)
        let tipoFin = this.getAllTiposSolicitud.find(item => item.codigoTipoSolicitud == this.codTipoSelected)
        let observaciones = this.localization.textoCambioTipo.replace('@tipoIni@', this.mostrarIdioma(tipoInicial)).replace('@tipoFin@', this.mostrarIdioma(tipoFin))+ " - " + this.observaciones
        let idEstado = this.solicitud.estadoId ? this.solicitud.estadoId : this.solicitud.stateId

        let values = {
            incidenceId: this.solicitud.id,
            statusId: idEstado,
            codigoTipoSolicitud: this.codTipoSelected,
            observaciones: observaciones,
            updateDate: this.statusDate,
        }

        this.$emit('updateData', values)
        this.$parent.hide()
      }
    },
    evitarKeyPress (event) {
      event.preventDefault()
    },
    mostrarIdioma (item) {
      if (item.translates && item.translates[this.usuario.idioma] && item.translates[this.usuario.idioma].length > 0 ) {
        return item.translates[this.usuario.idioma]
      } else {
        return item.name || item.description || item.text || ''
      }
    }
  },
  watch: {
    codTipoSelected () {
      this.cambiado = true
    },
  }
}
</script>

<style scoped>

</style>
